<template>
  <div class="ServicesList">
     
    <div
      class="header w100 fff d-flex j-sb"
      style="height:54px;padding:0 12px;font-size:0.875rem; !important;"
    >
      <div class="d-flex a-center j-center h100" style="line-height: 54px">
        <div class="h100" style="margin-left:20px;color: #000;">
          <i class="el-icon-s-custom"></i>欢迎您，管理员
        </div>
      </div>
      <div class="refresh" title="刷新"><i class="el-icon-refresh-right" @click="reset"></i></div>
    </div>
    <div>
      <div class="box">
        <!-- =================================================tab表格区域============================================================== -->
        <div class="d-flex p-top-2 p-right-4" >
          <div class="d-flex">
            <santakinput
              santakLabel="报名截止时间："
              fieldName="startTime"
              :defaultValue="queryInfo.startTime"
              field="queryInfo"
              width="150"
              label-width="120"
            ></santakinput>
            <santakinput
              santakLabel="会议主题："
              fieldName="activityName"
              field="queryInfo"
              width="150"
              labelWidth="120"
              :defaultValue="queryInfo.activityName"
            ></santakinput>

            <santakinput
              santakLabel="主办方："
              fieldName="sponsor"
              field="queryInfo"
              width="150"
              labelWidth="120"
              :defaultValue="queryInfo.sponsor"
            ></santakinput>
          </div>
            <santakButton title="查询" @clickHandle="searchByConditions" style="margin-left: 60px"></santakButton>
        </div>
          <div style="margin-top: 20px">
            <santakButton title="新增" @clickHandle="addNewMeeting"></santakButton>           
          </div>
        <el-table
          border
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; margin: 20px 0"
        >
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="startTime"
            label="报名截止时间"
          >
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            align="center"
            label="会议主题"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.activityName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="participation"
            label="参与人数"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.participation }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="activityAddress"
            label="会议地址"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.activityAddress }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="sponsor"
            label="主办方"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.sponsor }}
              </div>
            </template></el-table-column
          >
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="coSponsor"
            label="协办方"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.coSponsor }}
              </div>
            </template></el-table-column
          >
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop="organizer"
            label="赞助商"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.organizer }}
              </div>
            </template></el-table-column
          >
          <el-table-column
            show-overflow-tooltip
            align="center"
            prop=""
            label="操作"
            width="300"
          >
            <template slot-scope="scope">
              <div class="operator">
                <span @click="checkSign(scope)" class="check">查看报名</span>
                <span @click="editSignUp(scope)">编辑</span>
                <span @click="deleteSignUp(scope)" class="delete">删除</span>
                <span @click="downloadSignUpCode(scope)" class="downloadCode">下载报名二维码</span>
                <!-- <el-button size="mini" @click="checkSign(scope)">查看报名</el-button>
                <el-button size="mini" @click="editSignUp(scope)">编辑</el-button>
                <el-button size="mini" @click="deleteSignUp(scope)">删除</el-button>
                <el-button size="mini" @click="downloadSignUpCode(scope)">下载报名二维码</el-button> -->
              </div>
            </template></el-table-column
          >
        </el-table>

        <!-- 分配请求 -->
        <div class="f-md main-text-color d-flex a-center" style="">
          <div class="fontsize">
            显示第 {{ startPagination }} 到第
            {{ endPagination > total ? total : endPagination }} 条记录,
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
        <!-- =================================================tab表格区域============================================================== -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryActivities,
  activityDelete,
  generateCode
} from "../../api/serviceRequestAdmin";
import Location from '../../components/Location.vue';
import mixins2 from "../../mixin/mixins2";
export default {
  components: { Location },
  name: "Index",
  mixins: [mixins2],
  data() {
    return {
       
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        activityName: "", 
        startTime: "", 
        endTime: "", 
        sponsor: "", 
        coSponsor: "", 
        organizer: "",
        activityAddress: "", 
      },
      tableData: [],
      total: null,
      endPagination: "",
      startPagination: ""
    };
  },
  async mounted() {
    this.getTableData();
  },
  methods: {
    
    // 查询
    query() {
      this.queryInfo.pageNum = 1;
      this.getTableData();
    },
    searchByConditions() {
      this.query()
    },
    reset() {
      let { pageNum, pageSize } = this.queryInfo;
      this.queryInfo = {
        pageNum: 1,
        pageSize,
        activityName: "", 
        startTime: "", 
        endTime: "", 
        sponsor: "", 
        coSponsor: "", 
        organizer: "",
        activityAddress: "", 
      },
      this.getTableData();
    },
    addNewMeeting() {
      this.$router.push({name: 'NewMeeting'})
    },
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(page) {
      this.queryInfo.pageNum = page;
      this.getTableData();
    },
    async getTableData() {
      let obj = Object.assign({}, this.queryInfo);
      // console.log(obj)
      try {
        const res = await queryActivities(obj);
        if (res.status == 200) {
          let { navigateFirstPage, navigateLastPage, total } = res.result;
          this.tableData = res.result.list;
          this.total = total;
          this.startPagination = navigateFirstPage;
          this.endPagination = navigateLastPage;
        }
      } catch (error) {
      }
    },
    
    checkSign(scope) {
      const {id:activityId,activityName,startTime} = scope.row
      this.$router.push({name: 'Manage', query: {
        activityId,
        activityName,
        startTime,
      }})
    },
    editSignUp(scope) {
      this.$router.push({
        name: 'NewMeeting',
        query: {
          data: encodeURIComponent(JSON.stringify(scope.row))
        }
      })
    },
    async deleteSignUp(scope) {
      try {
        await this.$confirm("确定删除该会议？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        console.log(scope);
        const res = await activityDelete(scope.row.id);
        if (res.status == 200) {
          this.$message.success('删除成功！')
          this.reset();
        }
      } catch (error) {
        this.$message('已取消')
      }
    },
    async downloadSignUpCode(scope) {
      const res = await generateCode({
        "scene": scope.row.id,
        "path": "pages/index/index"
      })
      window.open(res.result)
    },

    
  },
};
</script>

<style scoped lang="less" scoped>
.ServicesList /deep/ .el-form-item {
  margin-bottom: 0 !important;
}
.ServicesList .box {
  margin-top: 0 !important
  
}
.ServicesList .box /deep/ .el-dialog {
  width: 1038px !important;
}
.ServicesList .owner /deep/ .el-select {
  width: 17.1875rem !important;
  height: 46px !important;
}
.optionSelect /deep/ .el-select {
  width: 21.875rem !important;
  height: 46px !important;
}

.box {
  padding: 0px 12px;
}
.bgc {
  background: #eee !important;
  padding-bottom: 5px;
}
.red {
  color: #de1e23;
}
.el-icon-s-custom {
  font-size: 16px;
  margin-right: 10px;
}
.refresh {
  margin-right: 80px;
  font-weight: 800;
  font-size: 24px;
  cursor: pointer;
}
.header {
  border-bottom: rgba(0, 21, 41, 0.08) !important
}
.operator {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.operator .delete {
  color: #de1e23
}
.check,.downloadCode {
  color: #3399cc
}

</style>
